export class User {

  id: string;
  email: string;
  firstName: string;
  lastName: string;
  
  public constructor(init?:Partial<User>) {
    Object.assign(this, init);
    this.email = this.email != null ? this.email.toLowerCase() : null;
    this.id = this.id != null ? this.id.toLowerCase() : null;
  }

  get name(): string {
    if (this.firstName == null || this.firstName.trim() == '' || this.lastName == null || this.lastName.trim() == '') {
      return null
    } else {
      return this.firstName.toCapitalized() + " " + this.lastName.toCapitalized()
    }
  }

  static fromRecord(record) {
    return new User({
      email: record.user_email,
      firstName: record.user_first,
      id: record.user_id,
      lastName: record.user_last
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/users/user.model.ts